import { createFileRoute } from '@tanstack/react-router';

import GeneeaEntityForm from './-components/GeneeaEntityForm';

export const Route = createFileRoute('/_authenticated/geneea-entities/$id')({
    component: GeneeaEntityForm,
});
